import ModalStyle from '../core/modalStyle';
import ProcessingRequestsStyle from './ProcessingRequestsStyle';

const EscalatedRequestsStyle = () => ({
  ...ModalStyle(),
  ...ProcessingRequestsStyle(),
  blockReasonSelect: {
    width: '80%',
  },
  note: {
    width: '80%',
  },
  filterLabel: {
    marginBottom: 5,
    color: 'grey',
  },
});

export default EscalatedRequestsStyle;
